export default {
      id: "trash2-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#trash2",
      toString: function () {
        return this.url;
      }
    }